const f = (g, e) => typeof (e == null ? void 0 : e.href) == "string" ? ["a", e, ["img", g]] : ["img", g];
export {
  f as getImageWithLinkHtml
};
